<template>
  <div class="login">
    <div class="top">
      <div class="title-sc">码上-3G48-AI智慧大数据云视频平台</div>
      <!-- <div class="title-en">Precision Employment Poverty Alleviation Information Management System</div> -->
    </div>
    <div class="box">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item style="margin-top:32px;" prop="name">
          <el-input type="text" size="large" v-model="ruleForm.name" placeholder="请输入用户名">
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item style="margin-top:32px;" prop="password">
          <el-input type="password" size="large" v-model="ruleForm.password" placeholder="请输入密码">
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top:32px;">
          <el-button size="large" type="primary" @click="submit" style="width:200px;">登&nbsp;&nbsp;&nbsp;录</el-button>
          <el-button size="large" type="primary" @click="register" style="width:200px;">注&nbsp;&nbsp;&nbsp;册</el-button>
        </el-form-item>
        <el-form-item style="margin-top:32px;">
          <div class="box2">
            <span class="forgetlink" @click="forgetPsd">忘记密码？</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    
    <el-dialog :visible.sync="isShowDialog" :close-on-click-modal="false" title="找回密码" center width="500px">
      <!-- 内容 -->
      <el-form :model="forgetData" label-width="110px">
        <el-form-item label="手机号">
          <el-input clearable size="large" style="width:280px;" v-model="forgetData.phone"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input clearable size="large" style="width:186px;margin-right:10px;" v-model="forgetData.code"></el-input>
          <el-button size="large" type="success" @click="getCode" :disabled="forgetData.disabled">{{forgetData.btnstr}}</el-button>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input type="password" clearable size="large" style="width:280px;" v-model="forgetData.password"></el-input>
        </el-form-item>
      </el-form>
      <!-- 足部 -->
      <div slot="footer">
        <el-button type="primary" size="large" @click="submitCode">确 定</el-button>
        <el-button size="large" @click="isShowDialog=false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      ruleForm:{ name: '', password: '', yzm: '' },
      rules:{
        name:[ { required: true, message: '请输入用户名' } ],
        password:[ { required: true, message: '请输入密码' } ],
        // yzm:[ { required: true, message: '请输入验证码' } ]
      },

      isShowDialog: false,
      forgetData: {
        phone: '',
        code: '',
        password: '',
        disabled: false,
        btnstr: '验证码',
      },
      Timenum: 180,//发送验证码的间隔时间
    }
  },
  methods: {
    ...mapMutations(['fixedArea_save']),
    forgetPsd() {
      this.forgetData = {
        phone: '',
        code: '',
        password: '',
        disabled: false,
        btnstr: '验证码',
      }
      this.isShowDialog = true
    },
    getCode() {
      let phone = this.forgetData.phone
      const reg = /^1[3|4|5|6|7|8]\d{9}$/
      if (reg.test(phone)) {
        this.forgetData.disabled = true //输入的号码格式正确，按钮变为不可点
        this.$api._user_SendCode({phone:phone}).then(res => {})
        //前端页面效果
        let timer = setInterval(() => {
          this.Timenum--
          this.forgetData.btnstr = this.Timenum+'s'
          if (this.Timenum <= 0) {
            clearInterval(timer)
            this.forgetData.btnstr = '验证码'
            this.forgetData.disabled = false
            this.Timenum = 180
          }
        },1000)
      } else {
        this.$message.info('请输入正确的手机号码')
      }
    },
    submitCode() {
      let { phone, code, password } = this.forgetData
      this.$api._user_forget(phone, code, password).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(_R)
          this.isShowDialog = false
        } else { this._status(res.data) }
      })
    },
    
    // 获取地理位置
    getArea(index, areaId, areaArrs) {
      console.log(`%cgetArea触发`, 'color: #00f;', Number(index), areaId)
      if (Number(index) < 4) {
        let rD = { areaId }
        return this.$api.getPlace(rD).then(res => {
          if (res.data.status === 0 ) {
            let _R = JSON.parse(res.data.data)
            // console.log(_R)
            const mapList = Object.keys(areaArrs)
            areaArrs[mapList[Number(index) + 1]] = _R
            // console.log(areaArrs.city)
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c已经是最后的村级了`, 'color: #f00;')
      }
    },
    //设置默认地址
    getDefault(areaArrs, areaNames, areaIds, dis) {
      let { admin, areaId } = this.userInfo
      if (admin) {
        for (let i = 0; i < 5; i++) { dis.push(false) }
      } else {
        return this.$api.getFather({ areaId }).then(async res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            console.log(`%c默认地区:`, 'color: #00f;', _R)
            _R.forEach((x, i) => {
              areaIds[x.level] = x.id
              areaNames[x.level] = x.name
              dis[x.level] = i !== 4
            })
            for (let i in areaIds) {
              // console.log(i, areaIds[i])
              await this.getArea(Number(i), areaIds[i], areaArrs)
              // console.log(areaArrs.city)
            }
            // areaIds.forEach(async (x, i) => { 
            //   await this.getArea(i, x, areaArrs)
            //   console.log(areaArrs.city)
            // })
            // console.log('save!!!!!!!!!')
            this.fixedArea_save({ areaArrs, areaNames, areaIds, dis })
          } else { this._status(res.data) }
        })
      }
    },
    async saveArea(_R) {
      let areaArrs = {
        province: [],
        city: [],
        county: [],
        town: [],
        village: [],
      }
      let areaNames = []
      let areaIds = []
      let dis = []

      if (this.userInfo.admin) {
        await this.getArea(-1, '0', areaArrs)
        this.fixedArea_save({ areaArrs, areaNames, areaIds, dis })
      } else if (this.areaIds_x.length === 0) {
        await this.getArea(-1, '0', areaArrs)
        this.getDefault(areaArrs, areaNames, areaIds, dis)
      } else{
      }
    },
    submit() {
      let vm = this
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          vm.$api._user_login(vm.ruleForm.name, vm.ruleForm.password).then(res => {
            let _d
            console.log(res)
            if (res.data.status === 0) {
              let tempData = JSON.parse(res.data.data)
              console.log(tempData)
              if (tempData.mustModifyPassword) {
                _d = () => vm.$router.push('selfPassword')
              } else {
                if (tempData.admin) {
                  _d = () => vm.$router.push('/map3')
                } else if (Array.from(tempData.privilegesList).indexOf("System-query-map") != -1 ) {
                  _d = () => vm.$router.push('/map3')
                } else {
                  tempData.organization ? _d = () => vm.$router.push('/companyInfo') : ''
                  tempData.personal ? _d = () => vm.$router.push('/userInfo') : ''
                }
              }
              this.userInfo_save(tempData)
              localStorage.setItem('loginData', res.data.data)
              this.saveArea(tempData)
              const loading = this.$loading({
                lock: true,
                text: '登录成功，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              setTimeout(() => {
                loading.close()
                _d()
              }, 1000)
            } else {
              this.$message.error('账号或密码错误')
            }
          })
        } else { return false }
      })
    },
    register() { this.$router.push('register') },


    keyupEnter() {
      document.onkeydown = e =>{
        if (e.keyCode === 13 && this.$route.path ==='/login') {
          this.submit()
        }
      }
    },
  },
  created() {
    this.keyupEnter()
  },
}
</script>

<style lang='scss' scoped>
.login{
  width: 100%;height: 100%;min-width: 1240px;min-height: 860px;
  display: flex;align-items: center;flex-direction: column;background: rgb(244,244,244);
}
.box{position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)}
.top{
  width: 100%;height: 100%;display: flex;align-items: center;flex-direction: column;
	background: url('../assets/login.png') no-repeat center center;background-size: 100% 100%;
  .title-sc{font-size: 60px;letter-spacing: 2px;color: rgb(255,255,255);margin-top: 80px;}
  .title-en {text-align: center;color: rgb(255,255,255);margin-top: 10px;font-size: 18px;}
}
.box2{
  display: flex;justify-content: center;
  .forgetlink{text-align: center;text-decoration: underline;color: #333;cursor: pointer;}
  .forgetlink:hover{color: red;}
}
</style>